export default "__VITE_ASSET__b4729486__"